export default __webpack_public_path__ + "static/media/ceto__purple.bd540453.svg";